"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreenameResolverTools = void 0;
const network_connection_types_1 = require("../../../networks/connections/network-connection.types");
const freename_resolver_provider_types_1 = require("./freename-resolver-provider.types");
class FreenameResolverTools {
    static networkNameFormFreenameNetwork(freenameNetwork) {
        switch (freenameNetwork) {
            case freename_resolver_provider_types_1.FreenameNetwork.BSC: return network_connection_types_1.NetworkName.BSC;
            case freename_resolver_provider_types_1.FreenameNetwork.ETHEREUM: return network_connection_types_1.NetworkName.ETHEREUM;
            case freename_resolver_provider_types_1.FreenameNetwork.POLYGON: return network_connection_types_1.NetworkName.POLYGON;
            case freename_resolver_provider_types_1.FreenameNetwork.POLYGON_MUMBAI: return network_connection_types_1.NetworkName.POLYGON_MUMBAI;
        }
    }
}
exports.FreenameResolverTools = FreenameResolverTools;
